
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface StatusFiltersProps {
  localFilters: VideoFilterOptions;
  handleStatusChange: (status: string, checked: boolean) => void;
}

const StatusFilters: React.FC<StatusFiltersProps> = ({
  localFilters,
  handleStatusChange,
}) => {
  return (
    <div>
      <h3 className="font-medium mb-2">Statut de publication</h3>
      <div className="grid grid-cols-2 gap-2">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="published" 
            checked={localFilters.statuses?.includes('published')}
            onCheckedChange={(checked) => handleStatusChange('published', checked === true)}
          />
          <Label htmlFor="published">Publiée</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="scheduled" 
            checked={localFilters.statuses?.includes('scheduled')}
            onCheckedChange={(checked) => handleStatusChange('scheduled', checked === true)}
          />
          <Label htmlFor="scheduled">Programmée</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="draft" 
            checked={localFilters.statuses?.includes('draft')}
            onCheckedChange={(checked) => handleStatusChange('draft', checked === true)}
          />
          <Label htmlFor="draft">Brouillon</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="unlisted" 
            checked={localFilters.statuses?.includes('unlisted')}
            onCheckedChange={(checked) => handleStatusChange('unlisted', checked === true)}
          />
          <Label htmlFor="unlisted">Non répertoriée</Label>
        </div>
      </div>
    </div>
  );
};

export default StatusFilters;
